__turbopack_context__.v({
  "answer": "CFaq-module__WK9tma__answer",
  "chevron": "CFaq-module__WK9tma__chevron",
  "empty": "CFaq-module__WK9tma__empty",
  "list": "CFaq-module__WK9tma__list",
  "question": "CFaq-module__WK9tma__question",
  "questionLabel": "CFaq-module__WK9tma__questionLabel",
  "root": "CFaq-module__WK9tma__root",
  "row": "CFaq-module__WK9tma__row",
  "rowActive": "CFaq-module__WK9tma__rowActive",
  "subtitle": "CFaq-module__WK9tma__subtitle",
});
